// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon{margin:0 auto;text-align:center;align-items:center}.plan{display:grid;grid-template-columns:64px 1fr;margin-bottom:8px;border-radius:8px;align-items:center;color:#666}.plan .fa-circle,.plan strong{color:#03b5da}.plan .fa-book-user{color:#fff}.plan h5{color:#666;display:grid;grid-template-rows:1fr}.title h5{color:#666}.price{display:grid;grid-template-columns:minmax(100px, 1fr) 16px minmax(100px, 1fr);color:#888}.price .cost{color:#666}\n", ""]);
// Exports
module.exports = exports;
